var _style, _circle, _g, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFDA44;}\n\t.st1{fill:#D80027;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.9,509.1c41.6-6.4,80-22.7,112.5-46.6L256,256L294.9,509.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.1,2.9c-41.6,6.4-80,22.7-112.5,46.6L256,256L217.1,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.6,462.4c32.5,23.9,70.8,40.3,112.5,46.6L256,256L104.6,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.6,104.6C25.7,137.1,9.3,175.4,2.9,217.1L256,256L49.6,104.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.9,294.9c6.4,41.6,22.7,80,46.6,112.5L256,256L2.9,294.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M509.1,217.1c-6.4-41.6-22.7-80-46.6-112.5L256,256L509.1,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M407.4,49.6C374.9,25.7,336.6,9.3,294.9,2.9L256,256L407.4,49.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M462.4,407.4c23.9-32.5,40.3-70.8,46.6-112.5L256,256L462.4,407.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 256,
    cy: 256,
    r: 89
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 66.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMk);
export default __webpack_public_path__ + "static/media/mk.a6409f41d0a51d905b8de6a1f9eb7588.svg";
export { ForwardRef as ReactComponent };